import { makeStyles } from '@material-ui/core/styles';

import { borderGreyColor, secondaryMono1 } from 'Styles/theme';

export const useStyles = makeStyles(() => {
	return {
		filterTreeContainer: {
			width: '100%'
		},
		filterHeader: {
			display: 'flex',
			cursor: 'pointer'
		},
		filterTitle: {
			display: 'flex',
			flex: 1,
			fontSize: 16,
			fontWeight: 500,
			textTransform: 'uppercase'
		},
		collapseIcon: { fontSize: 24 },
		filterValuesContainer: {
			marginTop: 10
		},
		filterValueBox: { minHeight: 38 },
		filterValueLabelRoot: {
			marginRight: 7,
			marginLeft: -7,
			flex: 1
		},
		filterValueLabel: {
			display: 'flex',
			flex: 1,
			justifyContent: 'space-between'
		},
		filterValueLabelText: {
			fontSize: 13
		},
		filterValueLabelParent: {
			fontWeight: 600
		},
		filterValueLabelCounter: {
			color: secondaryMono1
		},
		filterValueCheckboxRoot: {
			padding: 5,
			marginRight: 5
		},
		filterValueCheckBoxIcon: {
			fontSize: 20
		},
		childDivider: {
			backgroundColor: borderGreyColor
		},
		showMoreButton: {
			justifyContent: 'flex-start',
			padding: 0,
			marginTop: 10,
			'&:hover': {
				background: 'none'
			}
		},
		showMoreButtonLabel: {
			fontSize: 13,
			fontWeight: 400,
			color: secondaryMono1
		}
	};
});
